// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-877167f8] .app-sidebar-tabs__tab-caption,[data-v-877167f8] .app-sidebar-tabs__nav .checkbox-content__text{white-space:normal !important}`, "",{"version":3,"sources":["webpack://./src/components/board/BoardSidebar.vue"],"names":[],"mappings":"AAEC,kHAEC,6BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
